import React from "react";
import { RouteComponentProps } from "react-router";

import { formatDateTimeLocalNumeric, formatName } from "../../Utilities";

import FileUploadDialog from "../FileUploadDialog";

import DocumentImportEditor from "../DocumentImportEditor";

import withTitle from "../withTitle";
import { V2 } from "../../Api";
import { Link } from "react-router-dom";
import { RouteComponentPropsHistory } from "../../types";

interface IPatientDocumentUploadViewProps extends RouteComponentPropsHistory<any, any> {
}

interface IPatientDocumentUploadViewState {
    isUploadDialogOpen: boolean;
    documentInfo: any | null;
    importJobId: string | null;
    pendingImports: any[];
}

class PatientDocumentUploadView extends React.Component<IPatientDocumentUploadViewProps, IPatientDocumentUploadViewState> {
    constructor(props: Readonly<IPatientDocumentUploadViewProps>) {
        super(props);

        const state: IPatientDocumentUploadViewState = {
            isUploadDialogOpen: props.location.state?.defaultUploadOpen || false,
            documentInfo: null,
            importJobId: props.match.params.id || null,
            pendingImports: []
        };

        this.state = state;

        this.toggleUploadDialog = this.toggleUploadDialog.bind(this);
        this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
    }

    public componentDidMount() {
        this.setNewJobId(this.state.importJobId);
    }

    public componentDidUpdate(prevProps: Readonly<IPatientDocumentUploadViewProps>, prevState: Readonly<IPatientDocumentUploadViewState>) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.setNewJobId(this.props.match.params.id);
        }
    }

    public render() {
        return (
            <div className="viewer-root viewer-full full-height-max">
                <FileUploadDialog
                    isOpen={this.state.isUploadDialogOpen}
                    accept="application/pdf"
                    descriptionOverride={"-"}
                    endpoint="document/import"
                    closeOnSuccess={true}
                    onRequestClose={this.toggleUploadDialog}
                    onUploadSuccess={this.handleUploadSuccess} />
                {this.state.importJobId
                    ? this.renderDocumentInfo()
                    : this.renderLanding()}
            </div>
        );
    }

    private renderLanding() {
        return <>
            <p>
                You can upload scanned PDF files and import them into patients' charts.<br />
                If scanned documents have barcoded labels on them, the system will automatically sort the
                scanned pages into the correct patients' charts.
                <br />
                <br />
                <b>Note:</b> Simply renaming a file to have .pdf at the end <em>does not make it a PDF file.</em>
            </p>
            <div className="action-panel-dialog">
                <button type="button" className="button" onClick={this.toggleUploadDialog}>Select file...</button>
            </div>
            {this.state.pendingImports?.length > 0
                ? <div style={{ marginTop: "1em" }}>
                    There are {this.state.pendingImports?.length} pending import job(s):
                    <ul>
                        {this.state.pendingImports.map(a => <li key={a.id}>
                            <Link to={`/patient/document-import/${a.id}`}>{formatDateTimeLocalNumeric(a.creationTimestamp)} started by {formatName(a.creator.name)}</Link>
                        </li>)}
                    </ul>
                </div>
                : null
            }
        </>;
    }

    private renderDocumentInfo() {
        if (!this.state.importJobId) {
            return null;
        }

        return <DocumentImportEditor jobId={this.state.importJobId} />
    }

    private async setNewJobId(id: string | null) {
        if (!id) {
            try {
                const result = await V2.get<any>("document/import/pending");

                this.setState({
                    pendingImports: result.pendingImports
                });
            }
            catch (e) {

            }
        }

        this.setState({
            importJobId: id
        });
    }

    private toggleUploadDialog() {
        const isUploadDialogOpen = this.state.isUploadDialogOpen;

        this.setState({
            isUploadDialogOpen: !isUploadDialogOpen
        });
    }

    private handleUploadSuccess(ids: string[], results: any[]) {
        window.setTimeout(() => {
            this.props.history.push(`/patient/document-import/${ids[0]}`);
        }, 100);
    }
}

export default withTitle("Document Import", PatientDocumentUploadView);
